(function() {
  const now = new Date();

  const bfStart = new Date('2025-11-25T00:00:00-07:00');
  const bfEnd   = new Date('2025-12-01T00:00:00-07:00');
  const cmStart = new Date('2025-12-01T00:00:00-07:00');
  const cmEnd   = new Date('2025-12-04T07:59:59-07:00');
  
  let badgeType = null;
  let badgeText = '';

  if (now >= cmStart && now <= cmEnd) {
    badgeType = 'cm__promo';
    badgeText = window.promotionBadgeText?.cm || 'Cyber Monday Sale';
  } else if (now >= bfStart && now < bfEnd) {
    badgeType = 'bf__promo';
    badgeText = window.promotionBadgeText?.bf || 'Black Friday Sale';
  }

  if (!badgeType) return;

  const addPromotionBadges = () => {
    const productCards = document.querySelectorAll('.card-wrapper.product-card-wrapper');

    productCards.forEach(card => {
      if (!card.querySelector('.promotion-badge__cont')) {
        const badge = document.createElement('div');
        badge.className = `promotion-badge__cont ${badgeType}`;
        badge.innerHTML = `<p>${badgeText}</p>`;
        card.insertBefore(badge, card.firstChild);
      }
    });
  };

  addPromotionBadges();
  setTimeout(addPromotionBadges, 500);

  const productGrid = document.querySelector('#product-grid');
  if (productGrid) {
    new MutationObserver(addPromotionBadges).observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
})();